# Mock objects

There are a number of manually curated mock objects available in the [Playground] environment.
Each object is uniquely identified by an [object identifier] string.

## Application questionnaires

| Identifier                                                               |
| ------------------------------------------------------------------------ |
| `seekAnzPublicTest:applicationQuestionnaire:rrv2:SqFmkV8S2dMipyqbHjD9Mr` |
| `seekAnzPublicTest:applicationQuestionnaire:rrv2:Jx1Gnnkf8uxhR3TeCkNsSK` |

## Advertisement brandings

| Identifier                                                                    |
| ----------------------------------------------------------------------------- |
| `globalPublicTest:advertisementBranding:hirerBranding:37EWfWxhwVEGTT5BcjfE2L` |
| `globalPublicTest:advertisementBranding:hirerBranding:5DU2L2vQsyTXuu9NEUKT3f` |
| `globalPublicTest:advertisementBranding:hirerBranding:9Rw3f4qpkwv4poHjTwdu6K` |
| `globalPublicTest:advertisementBranding:hirerBranding:BYAZKaoXhS9LHFMv5gJ87e` |

## Advertisement products

| Identifier                                                                        | Ad type    | Job update                                          |
| --------------------------------------------------------------------------------- | ---------- | --------------------------------------------------- |
| `globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbCR3cKV9WdNSMC6e1vqiUJ` | `Classic`  | Create only                                         |
| `globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFbByJ1JVteAQQkfa3uMJLPJ` | `StandOut` | Create only                                         |
| `globalPublicTest:adProduct:seekApi:EWHKTY9D6mJFiA5EH6P7MFaUj6LchctVWMg2zsCHxbpQ` | `Premium`  | Create only                                         |
| `globalPublicTest:adProduct:seekApi:GxWYyP4HtLsXHEVMJFcPoRw29chXnRTDdvbZz1sQZQ1Q` | `Classic`  | `seekAnzPublicTest:positionProfile:jobAd:2782PZfXV` |
| `globalPublicTest:adProduct:seekApi:GxWYyP4HtLsXHEVMJFcPoRw1hs6WoAakfu13TRkq21vQ` | `StandOut` | `seekAnzPublicTest:positionProfile:jobAd:2782PZfXV` |
| `globalPublicTest:adProduct:seekApi:GxWfPGp6WAZMZMndU84euf7d5DHk9duMyFCPoe8nvYkk` | `Premium`  | `seekAnzPublicTest:positionProfile:jobAd:28cfuo97M` |

## Candidates

### SEEK candidates

| Identifier                                                        | Name             |
| ----------------------------------------------------------------- | ---------------- |
| `seekAnzPublicTest:candidate:feed:5PGXAHysiXhtA9JUqhyM8hhzMuWMPA` | Riley Doherty    |
| `seekAnzPublicTest:candidate:feed:5PGXAHysjZdkQYwZghfL4bRCqvZ7ZM` | Amelia Collins   |
| `seekAnzPublicTest:candidate:feed:5PGXAHysRLRreMSV17fuC5b8qmBg6C` | Ella Greenholt   |
| `seekAnzPublicTest:candidate:feed:5f1Yht6N8e9nZ42UygrWn2m6sSQ95s` | Hamish Alexander |
| `seekAnzPublicTest:candidate:feed:5f1Yht6NVesExMZaYgL49mvwkD7tUs` | Hayden           |
| `seekAnzPublicTest:candidate:feed:5f1Yht6NJyHSumX6xNxQm73PdWEuUi` | Owen Schultz     |
| `seekAnzPublicTest:candidate:feed:5PGXAHysr9oiPkWWUb4pt9msjLFZCm` | Alice Waelchi    |

### Uploaded candidates

| Identifier                                                   | Name          |
| ------------------------------------------------------------ | ------------- |
| `globalPublicTest:candidate:uploaded:12uNaG7vqgW6G1jG7qp7ha` | Marcus Damore |

## Candidate profiles

### Application profiles

The identifier suffixes should be prepended with `seekAnzPublicTest:candidateProfile:apply:` to create a candidate profile ID.

| Identifier suffix        | Attachments                | Has questionnaire | Most recent role |
| ------------------------ | -------------------------- | ----------------- | ---------------- |
| `7DtW6Q68gk2R4okNGhvg1Y` | None                       | Yes               | New to workforce |
| `4QM5fWQbdekL9gPtPZrzex` | Resume, cover letter       | Yes               | In past          |
| `5G5NaFDmy7UigvGy6aT6VT` | Cover letter               | No                | Current          |
| `8LKX1QrkJk5JuU2AfW6tsc` | Resume, cover letter       | No                | New to workforce |
| `UHeZTe27g1ZJZoHMiwzmPJ` | Selection criteria         | No                | In past          |
| `T87M4jzTT8or3qVt8DuBP9` | Resume, selection criteria | Yes               | Current          |
| `DRwKishTjgDrgoJV8sCHR3` | Resume                     | Yes               | In past          |
| `HmvRHVfJ7FBJMz6jPKuCkQ` | Resume, cover letter       | No                | In past          |
| `MhnVEhKTkCY7t7mAMYRYCB` | Resume (image as a PDF)    | Yes               | Current          |

### Purchased profiles

| Identifier                                                  | Name               |
| ----------------------------------------------------------- | ------------------ |
| `seekAnzPublicTest:candidateProfile:purchased:73nRti9c7jBm` | Alexander Watsford |

### Uploaded profiles

| Identifier                                                          | Name          |
| ------------------------------------------------------------------- | ------------- |
| `globalPublicTest:candidateProfile:uploaded:7m7JgSEM2rkAwrxoBrfPyV` | Marcus Damore |

### Apply with SEEK Profiles

| Identifier                                                         | Type                                         |
| ------------------------------------------------------------------ | -------------------------------------------- |
| `globalPublicTest:candidateProfile:prefill:PoJo9PPLL9wEF6z5nvMP9d` | Maximal example with a complete SEEK Profile |
| `globalPublicTest:candidateProfile:prefill:NviKaXd9grZUaWZx3NEy3m` | Minimal example with an email address only   |

## Hirers

| Identifier                                     | Relationships with Playground partner |
| ---------------------------------------------- | ------------------------------------- |
| `seekAnzPublicTest:organization:seek:93WyyF1h` | All                                   |
| `seekAnzPublicTest:organization:seek:9YQA3jYK` | `ApplicationExport` only              |
| `seekAnzPublicTest:organization:seek:E2LikAHu` | None                                  |

## Job categories

| Identifier                                     | Job category                                     |
| ---------------------------------------------- | ------------------------------------------------ |
| `seekAnzPublicTest:jobCategory:seek:27HXTkNXh` | Design & Architecture - Web & Interaction Design |
| `seekAnzPublicTest:jobCategory:seek:2PiXemmou` | Retail & Consumer Products - Retail Assistants   |

## Locations

| Identifier                                  | Location                                   |
| ------------------------------------------- | ------------------------------------------ |
| `seekAnzPublicTest:location:seek:W7NggeKH`  | Auckland › Auckland Central                |
| `seekAnzPublicTest:location:seek:2m81wybwV` | Melbourne › CBD & Inner Suburbs            |
| `seekAnzPublicTest:location:seek:8WVUnymq`  | Russia & Eastern Europe                    |
| `seekAnzPublicTest:location:seek:2vArzkyio` | Sydney › CBD, Inner West & Eastern Suburbs |
| `seekAnzPublicTest:location:seek:2beMJFcmV` | UK & Ireland                               |

## Position openings

| Identifier                                                          | Position profiles |
| ------------------------------------------------------------------- | ----------------- |
| `globalPublicTest:positionOpening:positions:E3Lz6HkSrbZCawh4gPGAtM` | None              |
| `globalPublicTest:positionOpening:positions:F65aT5rAv3ZSusuunFWT8i` | Posted only       |
| `globalPublicTest:positionOpening:positions:876y9hibtZZvv6vgtQx4zd` | Unposted only     |
| `globalPublicTest:positionOpening:positions:X1KiHhcuHWggkb6ydd9wyM` | Posted & unposted |

## Position profiles

These position profiles are owned by [hirers with different relationships] to the Playground partner.
You can only run position profile mutations for hirers you have a `JobPosting` relationship with.

### Posted position profiles

| Identifier                                          | Relationships            |
| --------------------------------------------------- | ------------------------ |
| `seekAnzPublicTest:positionProfile:jobAd:2782PZfXV` | All                      |
| `seekAnzPublicTest:positionProfile:jobAd:27cuZeA47` | All                      |
| `seekAnzPublicTest:positionProfile:jobAd:297Z5sddy` | All                      |
| `seekAnzPublicTest:positionProfile:jobAd:287njieaj` | `ApplicationExport` only |
| `seekAnzPublicTest:positionProfile:jobAd:28cfuo97M` | `ApplicationExport` only |

### Unposted position profiles

| Identifier                                                         | Relationships |
| ------------------------------------------------------------------ | ------------- |
| `globalPublicTest:positionProfile:unposted:GSg8dZtux2FD8hP4Bmju3B` | All           |
| `globalPublicTest:positionProfile:unposted:QnwpqZfzXu1NRmZw5tjswn` | All           |

## Webhook subscriptions

| Identifier                                                            | Event type                    |
| --------------------------------------------------------------------- | ----------------------------- |
| `seekAnzPublicTest:webhookSubscription:events:BoJiJ9ZWFVgejLXLJxUnvL` | `CandidateApplicationCreated` |
| `seekAnzPublicTest:webhookSubscription:events:CNmTxcSwNLgH8ZkssMCusC` | `CandidateApplicationCreated` |
| `seekAnzPublicTest:webhookSubscription:events:RNzsabxEX56cuRepCD9A8j` | `HirerRelationshipChanged`    |
| `seekAnzPublicTest:webhookSubscription:events:9H6GD9v2o8hQw7aBBG2sAU` | `PositionProfileClosed`       |
| `seekAnzPublicTest:webhookSubscription:events:T4HEUGJRpD3cpUSZ7xXWYL` | `PositionProfilePosted`       |
| `seekAnzPublicTest:webhookSubscription:events:V5aXuWdqmh2mzERRn44W22` | `PositionProfilePosted`       |
| `seekAnzPublicTest:webhookSubscription:events:D5Xa1QrddYJSSdnfVnXwHi` | `PositionProfileUpdated`      |

[playground]: /graphql/playground
[hirers with different relationships]: /auth/hirer-relationships
[object identifier]: /graphql/seek-api-conventions#object-identifiers
